import styled from "styled-components";
import { StyledText } from "../../../../components/common";
import loadingGif from "../../../../components/images/loader.gif";

import React from "react";

const LoadingUI = ({ text = "Loading..." }) => {
  return (
    <MainHolder>
      <Children>
        <div>
          <img
            alt={"dialog"}
            src={loadingGif}
            style={{ width: "100%", margin: "0 auto" }}
          />
          <StyledText>{text}</StyledText>
        </div>
      </Children>
    </MainHolder>
  );
};

export default LoadingUI;

const MainHolder = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px 0;
  text-align: center;
`;

const Children = styled.div`
  height: 100%;
  width: 200px;
`;
